export * from './commands.service';
export * from './screen.service';
export * from './settings.service';
export * from './state.service';
export * from './tariff.services';
export * from './http';
export * from './data';
export * from './app.service';



// WEBPACK FOOTER //
// ./src/app/shared/services/index.ts